import { ReactNode } from "react";
import "../../style/icons.css";
import { SidewaysCrystal } from '../Crystal/SidewaysCrystal';
import { iconMapping } from "../../models/CardAbility";
import { LBIcon } from "../Icons/LBIcon";

const textTagFunctions: Record<string, (children: ReactNode[], key: string) => ReactNode> = {
    "|": (children, key) => (
        <span key={key} className="bg-emphasis text-emphasis-contrast">{children}</span>
    ),
    "~": (children, key) => (
        <span key={key} style={{ fontStyle: "italic" }}>{children}</span>
    ),
    "%": (children, key) => (
        <span key={key} className="specialText">{children}</span>
    ),
    "*": (children, key) => (
        <span key={key} style={{ fontWeight: 700, fontFamily: "futura-pt-bold" }}>{children}</span>
    )
}

const getIconElement: (text: string, key: string) => ReactNode = (text, key) => {
    let icon = iconMapping[text];
    if (icon) {
        return <span key={key} className={"ff-icon " + icon}></span>
    }

    if (text === "crystalicon") {
        return <SidewaysCrystal key={key} className="h-4 w-4 inline-block ml-1 mb-1" />
    }

    if (text === "exburstlabel") {
        return <span key={key} className="ex-burst">EX BURST</span>
    }

    if (text === "limitbreakicon") {
        return <LBIcon key={key} classNames={{ svg: "h-4 w-4 inline-block -mt-1", path: "fill-white" }} />
    }

    return (
        <svg key={key} version="1.1" xmlns="http://www.w3.org/2000/svg" className="inline-block" height="15px" width="15px" x="0px" y="0px" viewBox="0 0 32 32" style={{ marginTop: "-5px" }}>
            <circle className="circle" cx="16" cy="16" r="15" />
            <text transform="matrix(1 0 0 1 8.9355 24.875)" className="circle-text">{text}</text>
        </svg>
    )
}

const tokenRegex = /{([^{]*)}|~([^~]*)~|%([^%]*)%|\*([^\*]*)\*|\|([^\|]*)\|/g;

function getSubstringElements(value: string): ReactNode[] {
    const matches = value.matchAll(tokenRegex);
    const parts = value.split(tokenRegex).filter(x => x !== undefined);
    const result: ReactNode[] = [];
    let partToReplace = 1;

    result.push(parts[0]);

    for (const match of matches) {
        const matchingText = match[0];
        const closingTag = matchingText[matchingText.length - 1];

        if (closingTag === "}") {
            const element = getIconElement(parts[partToReplace], partToReplace.toString());
            result.push(element);
        } else {
            const elementGenerator = textTagFunctions[closingTag];
            const content = parts[partToReplace];

            if (!elementGenerator) {
                result.push(content);
            } else {
                // See if string contains other tags.
                const recursiveResult = getSubstringElements(content);
                result.push(elementGenerator(recursiveResult, partToReplace.toString()));
            }
        }

        result.push(parts[partToReplace + 1]);
        partToReplace = partToReplace + 2;
    }

    return result;
}

export function AbilityText(props: { abilityText: string[] }) {
    return (
        <div className="flex flex-col">
            {
                props.abilityText.map((line, index) => {
                    return (
                        <div key={index} className={`${index > 0 ? "mt-2" : ""}`}>{getSubstringElements(line)}</div>
                    );
                })
            }
        </div>
    )
}

export function NewAbilityText(props: { abilityText: string }) {
    return (
        <div className="flex flex-col whitespace-pre-wrap font-normal">
            <div>{getSubstringElements(props.abilityText)}</div>
        </div>
    )
}